export const regexValidationServings = /^[0-9]{1,}$/;
